<template>
  <Table
    :toolbarHeading="toolbarHeading"
    :withToolbar="true"
    :withSearch="false"
    :withPagination="withPagination"
    :withDateRange="withDateRange"
    :tColumns="tColumns"
    :tData="tData"
    :fetch="getReferrals"
    :isSingleColspan="handleSingleColspan"
  >
    <template #table-toolbar>
      <slot name="referrals-table-toolbar"></slot>
    </template>

    <template #table-data-single="trData">
      <!-- statement row -->
      <div
        v-if="trData.is_last && isDateBeforeToday(trData.overview_endDate)"
        class="rounded-l rounded-r grid grid-cols-3 col-gap-3 shared-table-cells-cell-statement"
      >
        <div class="pl-4 text-left whitespace-normal">
          {{ `${trData && trData.statement_month} Rewards` }}
        </div>
        <div>
          Statement End Date
          {{ trData && trData.statement_date }}
        </div>
        <div class="pr-4 text-right">
          {{ trData && trData.statement_balance }}
        </div>
      </div>

      <!-- payment row -->
      <div
        v-else-if="trData.type === 'PAYMENT'"
        class="font-normal grid grid-cols-3 col-gap-3 shared-table-cells-cell-payment"
      >
        <div class="pl-4 text-left">
          Payment Made On
          {{ trData && trData.payment_date }}
        </div>
        <div>
          Payout Amount:
          <span class="px-1 font-bold">
            {{ trData && trData.payment_amount }}
          </span>
        </div>
        <div class="pr-4 text-right">
          Remaining Balance:
          <span class="px-1 font-bold">
            {{ trData && trData.payment_balance }}
          </span>
        </div>
      </div>
    </template>

    <template v-for="({ column }, index) in tColumns" v-slot:[`table-data-${index}`]="trData">
      <slot :name="`table-data-${index}`" v-bind="trData">{{ trData[column] }}</slot>
    </template>
  </Table>
</template>

<script>
import Table from './Table';
import { parseISO, isBefore } from 'date-fns';

export default {
  name: 'TableReferrals',
  components: { Table },
  props: {
    toolbarHeading: {
      type: String,
      required: false,
      default: 'referrals',
    },
    tData: {
      type: Object,
      required: false,
      default: () => {},
    },
    tColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    getReferrals: {
      type: Function,
      required: false,
      default: () => {},
    },
    withPagination: {
      type: Boolean,
      required: false,
      default: false,
    },
    withDateRange: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    isDateBeforeToday(date) {
      return isBefore(parseISO(date), parseISO(new Date().toISOString().slice(0, 10)));
    },
    handleSingleColspan({ is_last = false, overview_endDate = new Date(), type = '' }) {
      if (is_last && this.isDateBeforeToday(overview_endDate)) return true;
      if (type === 'PAYMENT') return true;
      return false;
    },
  },
};
</script>
